import { AlphaFiSDK } from 'alphafi-sdk-js';
import { getSuiClient } from './client';
/**
 * Validates and normalizes network string to supported network types
 * @param network - Network string to validate
 * @returns Validated network string, defaults to 'mainnet' if invalid
 */
export function validateNetwork(network) {
    const validNetworks = ['mainnet', 'testnet', 'devnet'];
    return validNetworks.includes(network)
        ? network
        : 'mainnet';
}
/**
 * Creates and returns an AlphaFiSDK instance with validated network configuration
 * @param network - Network string to validate
 * @param address - User wallet address
 * @returns Configured AlphaFiSDK instance
 */
export function createAlphaFiSDK(network, address) {
    const validatedNetwork = validateNetwork(network);
    const suiClient = getSuiClient(validatedNetwork);
    return new AlphaFiSDK({
        client: suiClient,
        network: validatedNetwork,
        address,
    });
}
